import { URL } from '../../constants/provider/constant';
import { _axios } from '../../plugins/axios';
export const getCallTypes = () => {

    let config = {
      method: 'get',
      url: URL.api_plus + 'MediMarketLookUp/calltype.json',
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }  
  
  
  export const getCallStatuses = () => {
  
    let config = {
      method: 'get',
      url: URL.api_plus + 'MediMarketLookUp/callstatus.json',
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }

  // export const addCorrespondence = (data) => {
  //   let config = {
  //       method: 'post',
  //       url: URL.procheck + 'AddCorrespondence',
  //       headers: {
  //           accesstoken: JSON.parse(localStorage.getItem("access_token")),
  //         },
  //       data : data
  //     };
    
  //     return _axios(config)
  //       .then((response) => response.data)
  //       .catch((error) => error);
  // }

  export const showCorrespondence = (id) => {
  
    let config = {
      method: 'get',
      url: URL.api_plus + '/RequestCorrespondence/153/0/'+id,
      headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
        }
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);

  }

  export const communicationHistory = (id) => {
  
    let config = {
      method: 'get',
      url: URL.api_plus + '/Request/Communication/'+id+'?showAllByRequestId=true&type=json',
      headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
        }
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);

  }